'use client';
import React, { startTransition, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchProps {
  onSearch: (searchValue: string) => void;
  placeholder?: string;
  className?: string;
  border?: boolean;
  inputClassName?: string;
  iconClassName?: string;
  clearIconClassName?: string;
  style?: object;
  value?: string;
}

const Search: React.FC<SearchProps> = ({
  onSearch,
  placeholder,
  className = '',
  border = true,
  inputClassName = '',
  iconClassName,
  clearIconClassName,
  style,
  value,
}) => {
  const [internalSearchValue, setInternalSearchValue] = useState<string>('');
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const { t } = useTranslation();

  const searchValue = value !== undefined ? value : internalSearchValue;
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (value === undefined) {
      setInternalSearchValue(newValue);
    }
    onSearch(newValue);
  };

  const clearSearch = () => {
    startTransition(() => {
      if (value === undefined) {
        setInternalSearchValue('');
      }
    });
    onSearch('');
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    if (!searchValue) {
      setIsFocused(false);
    }
  };

  return (
    <div className={`minthr-searchbar ${className}`}>
      <input
        type="text"
        value={searchValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`${border ? 'search minthr-mobile-w-100' : 'minthr-border-none'} ${inputClassName ? inputClassName : ''}`}
        placeholder={placeholder ?? t('Search')}
        style={style}
      />
      <span className={`search-icon ${iconClassName}`}></span>
      {isFocused && searchValue && (
        <button
          className={`search-clear minthr-border-none ${clearIconClassName}`}
          onClick={clearSearch}
        ></button>
      )}
    </div>
  );
};

export default Search;
